import React from 'react';
import { cn } from '@utils/cn';
import TextEditor from '../editor/fields/TextEditor';
import TextVariant, { getTextVariantUiProps } from '../editor/fields/TextVariant';
import * as Opt from '../editor/Helpers';

class Text extends React.Component {
    constructor() {
        super();
    }

    render() {
        const isEditor = window.location.pathname.includes('editor');
        const propsVisibility = this.props.visibility;
        const spacingClasses = Opt.CalculateSpacing(this.props.spacing);
        const { contentClasses, wrapperPaddingClasses } = Opt.splitTextSpacingClasses(spacingClasses);
        const visibilityClass =
            isEditor && ['dt', 'mob'].includes(propsVisibility)
                ? 'opacity-50'
                : propsVisibility === 'dt'
                  ? 'hidden lg:block'
                  : propsVisibility === 'mob'
                    ? 'lg:hidden'
                    : 'block';

        if (getTextVariantUiProps(this.props.textVariants, this.props.textVariant)) {
            return (
                <TextVariant
                    textVariants={this.props.textVariants}
                    textVariant={this.props.textVariant}
                    className={cn(visibilityClass, 'w-full min-w-0 max-w-full', wrapperPaddingClasses)}
                    align={this.props.align}
                    text={this.props.text}
                    innerClassName={contentClasses}
                />
            );
        }

        return (
            <div
                style={{ overflow: 'hidden' }}
                className={cn(
                    'legacy-bootstrap',
                    visibilityClass,
                    'w-full min-w-0 max-w-full [overflow-wrap:anywhere] quill-text',
                    wrapperPaddingClasses,
                    Opt.CalculateFontSize(this.props.fontSizes),
                    this.props.textStyle,
                    this.props.align,
                    contentClasses
                )}
                dangerouslySetInnerHTML={{ __html: this.props.text }}
            />
        );
    }
}

Text.defaultProps = {
    visibility: '',
    text: 'Lorem ipsum dolor sit amet.',
    align: 'text-start',
    spacing: [],
    fontSize: '',
    textStyle: '',
    textVariant: '',
    textVariants: []
};

Text.fields = {
    text: {
        type: 'custom',
        render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} />
    },
    visibility: {
        type: 'select',
        options: Opt.visibilityOptions
    },
    align: {
        type: 'select',
        options: Opt.TextAlign
    },
    spacing: Opt.spacingOptions,
    fontSizes: Opt.fontSizeOptions,
    textStyle: {
        type: 'select',
        options: Opt.TextStyles
    },
    textVariants: Opt.textVariantOptions
};

export default Text;
